import React from 'react';
import Seo from './common/Seo';

import Drawer from "./common/Drawer";
import PageTitle from "./common/PageTitle";
import { useI18n } from "./i18n/I18nContext";
import { encodedContactEmail, getContactEmail } from './common/contactEmail';

function sypher(label) {
  return `<a class="motion-inline-link text-base font-bold text-dark underline transition duration-300 hover:opacity-50" data-desypher="${encodedContactEmail}" href="#" data-href="${btoa("mailto:" + getContactEmail())}">
      ${label}
    </a>`;
}

function Section({id, title, text, className}) {
    const { t } = useI18n();

    return (
        <section id={id} className={"relative overflow-x-clip px-10  pt-10" + (className ? " " + className : "")}>
          <div data-reveal className="max-w-[1200px] mx-auto">
            <h2 className="text-base font-bold text-dark uppercase">{title}{t("common.colon")}</h2>
            <br />
            <div className="text-base text-dark" dangerouslySetInnerHTML={{__html: text}} />
          </div>
        </section>
    );
}

function LegalNotice({route}) {
  const { t } = useI18n();
  const title = t("pages.legalNotice.title");
  const description = t("pages.legalNotice.description");
  const email = sypher(t("common.encrypted"));

  return [
    <Seo title={title} description={description} />,
    <PageTitle id="mentions-legales" title={t("pages.legalNotice.heading")} />,
    <Section id="editeur" title={t("pages.legalNotice.editorTitle")} text={t("pages.legalNotice.editorText", undefined, { email })} />,
    <Section id="directeur" title={t("pages.legalNotice.publicationDirectorTitle")} text={t("pages.legalNotice.publicationDirectorText")} />,
    <Section id="hebergeur" title={t("pages.legalNotice.hostingTitle")} text={t("pages.legalNotice.hostingText")} />,
    <Section id="contact" title={t("pages.legalNotice.contactTitle")} text={t("pages.legalNotice.contactText", undefined, { email })} />,
    <Section id="propriete-intellectuelle" title={t("pages.legalNotice.intellectualPropertyTitle")} text={t("pages.legalNotice.intellectualPropertyText")} />,
    <Section id="donnees-personnelles" title={t("pages.legalNotice.personalDataTitle")} text={t("pages.legalNotice.personalDataText", undefined, { email })} />,
    <Section id="chatbot-data" title={t("pages.legalNotice.chatbotTitle")} text={t("pages.legalNotice.chatbotText", undefined, { email })} />,
    <Section id="liens-hypertextes" title={t("pages.legalNotice.linksTitle")} text={t("pages.legalNotice.linksText")} />,
    <Section id="loi-applicable" title={t("pages.legalNotice.lawTitle")} text={t("pages.legalNotice.lawText")} className="pb-10" />,
    <Drawer route={route} />
  ];
}

export default LegalNotice;
